import axios from 'axios';
import BaseApi from './base';
import {
    EMPLOYEE,
    EMPLOYEE_UPDATE,
    GET_RATING,
    GET_COMMON_INFO,
    IFRAME_GET_COMMON_INFO,
    RESPOND_SILENT_OPERATOR_WARNING
} from '../constants/api';

export default class extends BaseApi {
    static get() {
        return axios.get(EMPLOYEE);
    }

    static update(data) {
        return axios.post(EMPLOYEE_UPDATE, data, {
            headers: {
                'Content-Type': `multipart/form-data; boundary="${Math.random().toString().substr(2)}"; charset=utf-8`,
            }
        });
    }

    static getRating() {
        return axios.get(GET_RATING);
    }

    static getCommonInfo() {
        return axios.get(GET_COMMON_INFO)
    }

    static getIframeCommonInfo() {
        return axios.get(IFRAME_GET_COMMON_INFO)
    }

    static respondSilentOperatorWarning(incidentId, action) {
        return axios.post(RESPOND_SILENT_OPERATOR_WARNING, this.stringify({
            incident_id: incidentId,
            action,
        }));
    }
}
